module.exports = __webpack_public_path__ + "static/img/banner1.3519b82.png";


//////////////////
// WEBPACK FOOTER
// ./static/jiaru/banner1.png
// module id = 6Bwe
// module chunks = 0